import { XMarkIcon } from "@heroicons/react/24/outline";
import { router, usePage } from "@inertiajs/react";
import { FormattedMessage } from "react-intl";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { Collaborator } from "../../../types/collaborator";
import { formatDate, LONG_DATE } from "@/utils/dates";

interface CollaboratorOffboardBannerInterface extends Pick<
    Collaborator,
    "license_terminated_at" | "primary_contact"
> {
    remainingDuration: number;
}

export default function CollaboratorOffboardBanner({
    collaborator,
}: {
    collaborator: CollaboratorOffboardBannerInterface;
}) {
    dayjs.extend(isSameOrBefore);
    const { realm } = usePage().props;

    const licenseEndDate = dayjs(collaborator.license_terminated_at);
    const now = dayjs();
    const hasExpired = licenseEndDate.isSameOrBefore(now, "day");
    const endDate = formatDate(
        collaborator.license_terminated_at,
        realm,
        LONG_DATE,
    );

    return (
        <div className="bg-voice">
            <div className="flex px-8 py-4 justify-between items-center">
                <div className="flex items-center">
                    <span className="text-white">
                        {hasExpired ? (
                            <FormattedMessage
                                id="Your organisation's license <strong>expired</strong> on <strong>:endDate</strong>. Access to the Voice Dashboard is now restricted."
                                values={{
                                    strong: (chunks) => (
                                        <strong>{chunks}</strong>
                                    ),
                                    endDate,
                                }}
                            />
                        ) : (
                            <FormattedMessage
                                id="Your organisation's license expires in <strong>:duration days</strong>. You will no longer be able to access your Voice Dashboard after <strong>:endDate</strong>."
                                values={{
                                    duration: collaborator.remainingDuration,
                                    strong: (chunks) => (
                                        <strong>{chunks}</strong>
                                    ),
                                    endDate,
                                }}
                            />
                        )}
                    </span>
                </div>
                <div className="flex items-center shrink-0 ml-4">
                    <a
                        href={`mailto:${collaborator.primary_contact}`}
                        className="font-medium border rounded-lg border-white hover:bg-voice-dark text-white px-4 py-2 "
                    >
                        <FormattedMessage id="Contact admin" />
                    </a>
                    <div>
                        <button
                            onClick={() =>
                                router.post(route("hide-offboard-banner"))
                            }
                        >
                            <XMarkIcon className="size-6 ml-4 mt-1 text-white z-10" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
